module.exports = __webpack_public_path__ + "static/media/scrambler.a71780d8.jpg";